(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["quick-view-modal"]) return;
  try {
    
  customElements.whenDefined('quick-view-modal').then(() => {
    const QuickViewModal = customElements.get('quick-view-modal');

    Object.defineProperties(QuickViewModal.prototype, {
      strategyName: {
        configurable: true,
        get() {
          return 'default';
        },
      },
      mobileStrategyName: {
        configurable: true,
        get() {
          return 'mobile';
        },
      },
    });

    const strategy = matchMedia('(min-width: 48rem)').matches ? 'default' : 'mobile';

    document.querySelectorAll('quick-view-modal').forEach((modal) => {
      modal.setStrategy(strategy);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
